module.exports = __webpack_public_path__ + "img/32.0f5ce556.png";